import { parentOf } from './the-parent-of-a-screen';
import { isAScreenToComeBackTo } from './the-screens-somebody-comes-back-to';

/**
 * Where a screen's own back arrow should go, as a URL that always resolves.
 *
 * WHY IT EXISTS. #491 moved the back arrow from `navCtrl.back()` (which undoes
 * the last navigation) to climbing the address tree, because somebody who had
 * bounced between two screens then pressed back walked their own footsteps in
 * reverse. It migrated the shared header, but two screens kept their own
 * `back()` on `navCtrl.back()`: the activity detail and the group detail. And
 * `navCtrl.back()` falls through to `history.back()`, which does NOTHING when
 * the page is the first entry in the history -- a cold start, a deep link, a
 * tap on a notification. That is the "the arrow does nothing" both pages were
 * reported with.
 *
 * This is the same rule the shared header uses, named once so the two pages can
 * share it: climb to the nearest screen the tree knows, and fall back to home
 * rather than to a no-op. It never returns `navCtrl.back()`, so the arrow
 * always moves.
 */
export const backTarget = (url: string): string =>
  parentOf(url, (candidate) => isAScreenToComeBackTo(candidate)) ?? '/home';
